import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime } from 'common/usual'
import { booleanString as boolStr } from 'common/usual'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CardActions,
  TablePagination
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'

const PartnerWorkoutResourceTable = props => {
  const { data, page, onPageChange } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Male Name</TableCell>
                  <TableCell>Partner</TableCell>
                  <TableCell>Workout Resource</TableCell>
                  <TableCell>Intensity</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data.rows && data.rows.map(resource => (
                  <TableRow className={'table-row'} key={resource.id} hover>
                    <TableCell>{resource.id}</TableCell>
                    <TableCell>{resource.name}</TableCell>
                    <TableCell>{resource.nameMale}</TableCell>
                    <TableCell>{resource.partner && resource.partner.name}</TableCell>
                    <TableCell>{resource.resource && resource.resource.name}</TableCell>
                    <TableCell>{resource.intensity}</TableCell>
                    <TableCell>{boolStr(resource.active)}</TableCell>
                    <TableCell>{formatDateTime(resource.createdAt)}</TableCell>
                    <TableCell>
                      <EditBtn history={props.history} path={`/partner-workout-resource/edit/${resource.id}`} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'flex-right'}>
        <TablePagination
          component="div"
          count={data.count || 0}
          onChangePage={onPageChange}
          page={page-1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

export default PartnerWorkoutResourceTable